<template>
    <mead-button-v2 class="dashboard-item-fitler-bar-button sm-r-xs"
        :class="[isSelectedSection ? 'el--active' : '']"
        :label="section.section_label"
        :lineStyle="'solid'"
        :transparent="!isSelectedSection"
        :colorStyle="isSelectedSection ? BUTTON_COLOR_STYLES.PRIMARY : BUTTON_COLOR_STYLES.DEFAULT"
        :size="BUTTON_SIZES.SMALL"
        @click="$emit('click', $event)">
        <template #before>
            <mead-status-indicator v-if="!isValid" :title="uiTitle" class="sm-r-s" />
        </template>
        <template #after>
            <mead-badge v-if="uiCount > 0" class="sm-l-s" cname="default" :lbl="uiCount" />
        </template>
    </mead-button-v2>
</template>
<script>
import { isNeObject } from '@aretheyhappy/utils';

export default {
    props: {
        /**
         * The configuration section this tab represents, including its section key,
         * label, and an isValid function used to validate the current config.
         */
        section: {type: Object, default: () => ({})},
        /**
         * The section key of the currently selected/active tab, used to highlight
         * this tab when it matches section.section.
         */
        selectedSection: {type: String, default: ''},
        /**
         * The current widget configuration, passed to section.isValid to determine
         * whether this tab's settings are complete/valid.
         */
        config: {type: Object, default: () => ({})}
    },
    data: function () {
        return {
            BUTTON_COLOR_STYLES: MeadCommon.BUTTON_COLOR_STYLES,
            BUTTON_SIZES: MeadCommon.BUTTON_SIZES,
        }
    },
    computed: {
        validation: function () {
            return this.section.isValid(this.config);
        },
        isValid: function () {
            return isNeObject(this.validation) ? this.validation.isValid : true;
        },
        uiTitle: function () {
            return isNeObject(this.validation) ? this.validation.errorMessages : '';
        },
        isSelectedSection: function () {
            return this.selectedSection === this.section.section;
        },
        uiCount: function () {
            return this.section.getCount(this.config);
        }
    }
}
</script>
<style lang="scss">
</style>